import { DARK_GREY, WHITE } from '@/components/ThemeContext/constants';

// Measured on /admin/jobs (NewUI/Jobs/styles.ts `jobPageContainer` and `jobPageHeader`).
export const styles = {
  root: { padding: 5, minWidth: 0, backgroundColor: WHITE },
  header: { paddingX: 2, marginBottom: 3, rowGap: 1 },
  titleRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: 3,
    rowGap: 2
  },
  // The family is restated because pages mount it in roots without the Scout theme.
  title: {
    margin: 0,
    minWidth: 0,
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '38px',
    fontWeight: 'bold',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: DARK_GREY
  },
  actions: { flexDirection: 'row', alignItems: 'center', columnGap: 1, marginLeft: 'auto' },
  description: {
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '14px',
    lineHeight: 1.5,
    color: DARK_GREY
  }
};
